import React, { useEffect, useState } from 'react'
import CustomTextField from '../../../../../components/custom_text_field/CustomTextField'
import { IoArrowBackSharp } from "react-icons/io5";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import './AdvanceClientFilterStyle.css'
import { useFormik } from 'formik';
import { ErrorToast, SuccessToast } from '../../../../../toast/toasts';
import AdvanceFilterable from './AdvanceFilterable';
import { get_client_lists_with_pagination } from '../../../../../api/clientApis';
import CustomBottomPagination from '../../../../../components/custom_bottom_pagination/CustomBottomPagination';

function AdvanceClientFilter({ is_open_modal, close_modal, selectedRowId, handleCheckboxChange }) {

    const navigate = useNavigate()
    const { client_id } = useParams()
    const [isView, setIsView] = useState(false)
    const [clientListing, setClientListing] = useState([])
    const [pageNumber, setPageNumber] = useState(1)
    const [totalPages, setTotalPages] = useState(0)
    const [totalItemPerPage, setTotalItemPerPage] = useState(10)



    const get_clients = (pageNumber, filterValue) => {
        const formData = new FormData();
        formData.append('page', pageNumber);
        formData.append('pageItem_count', totalItemPerPage);
        if (filterValue) {
            for (const key in filterValue) {
                formData.append(key, filterValue[key]);
            }
        }
        get_client_lists_with_pagination(formData).then((response) => {
            setClientListing(response?.data?.data)
            setTotalPages(response?.data.last_page)
        }).catch((error) => {
            let message = "";
            for (const key in error?.data?.errors) {
                if (error?.data?.errors.hasOwnProperty(key)) {
                    const keyMessages = error?.data?.errors[key].map(message => message);
                    message = message.concat(keyMessages);
                }
            }
            ErrorToast(message)
        })
    }

    const formik = useFormik({
        initialValues: {
            'name': '',
            'phone': '',
            'cd_email': '',
        },
        onSubmit: (values) => {
            if (values) {
                get_clients(pageNumber > 1 ? 1 : pageNumber, values)
                setPageNumber(pageNumber > 1 ? 1 : pageNumber)

            } else {
                get_clients(1, values)
                setPageNumber(1)
            }
        }
    });

    useEffect(() => {
        //CHECK THE SEARCH FILED HAVE ATEAST ONE VALUE
        const hasAtLeastOneValue =
            !!formik.values?.name ||
            !!formik.values?.phone ||
            !!formik.values?.cd_email;

        if (hasAtLeastOneValue) { //"At least one field has a value
            get_clients(pageNumber > 1 ? 1 : pageNumber, formik.values);
            setPageNumber(pageNumber > 1 ? 1 : pageNumber)
        } else {
            get_clients(pageNumber, null)
        }

    }, [pageNumber, totalItemPerPage])

    const ResetForm = () => {
        formik.setValues({
            ...formik.values, ...{
                'name': '',
                'phone': '',
                'cd_email': '',
            }
        })
        get_clients(1, null)
        setPageNumber(1)
        // close_modal(false)
    }

    const updatePagination = (pageNumber) => {
        setPageNumber(pageNumber)
    }
    const updateItemPageCount = (pageItemCount) => {
        setTotalItemPerPage(pageItemCount)
    }


    const Columns = [
        {
            title: "#",
            dataIndex: "key",
            key: "key",

        },
        {
            title: "Clients Name",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
        },
        {
            title: "Phone Number",
            dataIndex: "phone",
            key: "phone",
        },


    ];

    const datas = () => {
        const result =
            clientListing &&
            clientListing?.map((item, index) => {
                return {
                    key: pageNumber * totalItemPerPage - (totalItemPerPage - (index + 1)),
                    id: item.CI_id,
                    name: item.CI_name,
                    email: item.CI_email,
                    phone: item.CI_phone,
                    status: item.status_name,
                };
            });
        return result;
    };
    return (
        <div className={is_open_modal ? 'clients_form_super_container_modal' : 'clients_form_super_container'}>
            <div >
                {!is_open_modal && (
                    <div className='clients_form_action_sub_container'>
                        <div className='clients_form_single_row_alignment'>
                            <IoArrowBackSharp className='clients_form_back' onClick={() => {
                                navigate(-1)
                            }} />
                        </div>
                    </div>
                )}


                <div>
                    <form id="clientsform" onSubmit={formik.handleSubmit}>
                        <div className='clients_form_main_container'>
                            <p className="clients_form_legend">Details</p>
                            <div className='clients_form_sub_container_0'>
                                <div>
                                    <p className='clients_form_label'>Client Name</p>
                                    <CustomTextField
                                        isDisabled={isView}
                                        name="name"
                                        placeholder={"Enter client name"}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.name}

                                    />
                                </div>

                                <div>
                                    <p className='clients_form_label'>Email</p>
                                    <CustomTextField
                                        isDisabled={isView}
                                        name="cd_email"
                                        placeholder={"Enter email"}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.cd_email}

                                    />
                                </div>
                                <div>
                                    <p className='clients_form_label'>Phone Number</p>
                                    <CustomTextField
                                        isDisabled={isView}
                                        name="phone"
                                        type={"number"}
                                        placeholder={"Enter phone number"}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.phone}

                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                {is_open_modal && (
                    <div>
                        <div className='clients_form_single_row_alignment_modal'>
                            
                            <button className='clients_form_reset_button' onClick={() => {
                                // close_modal(false);
                                ResetForm()
                            }}>Reset</button>


                            {/* <button className='clients_form_reset_button' onClick={() => {
                                ResetForm()
                            }}>Close</button> */}
                            <button className='clients_form_save_button'
                                type="submit"
                                form="clientsform"
                            >Search</button>
                        </div>
                    </div>
                )}
            </div>
            <div style={{ marginTop: 10 }}>
                <AdvanceFilterable columns={Columns} rows={datas()} selectedRowId={selectedRowId} handleCheckboxChange={handleCheckboxChange} />
            </div>
            <div>
                <CustomBottomPagination total_items_per_page={totalItemPerPage} total_page_count={totalPages} current_page={pageNumber} on_change_value={updatePagination} on_page_count_update={updateItemPageCount} />
            </div>
        </div>
    )
}

export default AdvanceClientFilter
